import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';
import { Header } from '../Table/TableContent/TableContent.styles';

export const StatusHeader = styled(Header)`
  display: flex;
`;

export const StatusTitle = styled.div`
  ${({ theme }: IThemeProvider) => `
   margin-right: ${theme.layout.spacing.mikro};
`}
`;
